/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Tr_4_AInputs */

const en_mk_tut_tr_4_a = /** @type {(inputs: Mk_Tut_Tr_4_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A rule written in a single comment does not carry over to the next piece of work. Save it as an entry in Company memory so it is read on every run.`)
};

const id_mk_tut_tr_4_a = /** @type {(inputs: Mk_Tut_Tr_4_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aturan yang hanya ditulis di satu komentar tidak berlaku untuk pekerjaan berikutnya. Simpan sebagai entri di Memori perusahaan supaya ia dibaca setiap run.`)
};

/**
* | output |
* | --- |
* | "A rule written in a single comment does not carry over to the next piece of work. Save it as an entry in Company memory so it is read on every run." |
*
* @param {Mk_Tut_Tr_4_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_tr_4_a = /** @type {((inputs?: Mk_Tut_Tr_4_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Tr_4_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_tr_4_a(inputs)
	return en_mk_tut_tr_4_a(inputs)
});